<template>
  <div>
    <Breadcrumbs
      :paths="[$route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.term.title") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" :disabled="!refreshable" @click="get_data(get_prefix() + module, get_id())">
              mdi-refresh
            </v-icon>
          </template>
          <span>{{ $t("message.common.refresh") }}</span>
        </v-tooltip>
        <template v-if="mode === 'user'">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click="$router.push('/term/import')">
                mdi-import
              </v-icon>
            </template>
            <span>{{ $t("message.common.import") }}</span>
          </v-tooltip>
        </template>
      </v-toolbar-items>
    </v-toolbar>
    <v-card class="d-flex justify-center mt-1 pl-4">
      <GeneralSelect
        ref="general_select"
        :mode="mode"
        :label="$t('message.common.target')"
        layer_type="layer"
        :target_layer="['organization', 'group', 'user']"
        :target="target"
        v-on:update_target="target = $event; get_data(get_prefix() + module, get_id())"
        v-on:clear_target="reset_target(); data = []"
      >
      </GeneralSelect>
    </v-card>
    <v-card class="d-flex justify-center mt-1">
      <v-card flat class="pa-2">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          clearable
          :label="$t('message.common.yid')"
          v-model="search_yid"
        >
        </v-text-field>
      </v-card>
      <v-card flat class="pa-2">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          clearable
          :label="$t('message.common.title')"
          v-model="search_term"
        >
        </v-text-field>
      </v-card>
      <v-card flat class="pa-2">
        <v-select
          :label="$t('message.term.term_type')"
          :items="term_types"
          item-text="label"
          item-value="value"
          v-model="search_term_type"
          hide-details
          multiple
        >
        </v-select>
      </v-card>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="data"
      :sort-by="['ctime']"
      :sort-desc="[true]"
      must-sort
      class="term-table elevation-1 mt-1"
      @click:row="$vuetify.breakpoint.xs ? '' : $router.push('/' + get_prefix() + 'term/' + $event.yid + get_referer(module));"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 100]
      }"
    >
      <template v-slot:item.yid="{ item }">
        {{ item.yid }}
      </template>
      <template v-slot:item.name="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ item.name }}
            </span>
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.type="{ item }">
        <template v-if="item.type">
          {{ $t("message.term.term_type_" + item.type) }}
        </template>
        <template v-else>
          {{ $t("message.term.term_type_temporary") }}
        </template>
      </template>
      <template v-slot:item.lang_pair="{ item }">
        {{ $t("message.common.lang_" + item.lang_pair[0]) }}
        ,&nbsp;
        {{ $t("message.common.lang_" + item.lang_pair[1]) }}
      </template>
      <template v-slot:item.line="{ item }">
        {{ item.line | comma_digit }}
      </template>
      <template v-slot:item.ctime="{ item }">
        {{ $d(1000 * item.ctime, 'long', $store.getters.langs[$i18n.locale].locale) }}
      </template>
      <template v-slot:item.operation="{ item }">
        <template v-if="mode === 'user' && item.type === 'term'">
          <!--
          <template v-if="item.extensions.indexOf('json') >= 0 && deletable(item)">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="ma-2" @click.stop="$router.push('/editor/term/' + item.yid + '?referer=' + nav_path)">
                  mdi-book-open
                </v-icon>
              </template>
              <span>{{ $t("message.term.edit_term") }}</span>
            </v-tooltip>
          </template>
          -->
        </template>
        <template v-if="deletable(item)">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="confirm_delete_data(get_prefix() + 'term', [item.yid], get_id())">
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t("message.common.delete") }}</span>
          </v-tooltip>
        </template>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click.stop="$refs.parallel_viewer && $refs.parallel_viewer.open(item.name, 'term', item.yid)">
              mdi-file-find
            </v-icon>
          </template>
          <span>{{ $t("message.viewer.preview") }}</span>
        </v-tooltip>
      </template>
      <template v-if="$vuetify.breakpoint.xs" v-slot:item.action="{ item }">
        <v-btn color="primary" class="mb-2" @click="$router.push('/' + get_prefix() + 'term/' + item.yid + '?referer=' + nav_path)">
          {{ $t("message.common.show_details") }}
        </v-btn>
      </template>
    </v-data-table>
    <p class="text-right pt-3">
      <v-btn to="/">
        {{ $t("message.common.return_home") }}
      </v-btn>
    </p>
    <Confirm
      ref="delete_confirm"
      :message="$t('message.common.delete_confirm')"
      :positive="$t('message.common.yes')"
      :negative="$t('message.common.no')"
    >
    </Confirm>
    <ParallelViewer
      ref="parallel_viewer"
      :mode="mode"
    ></ParallelViewer>
    <v-overlay
      :absolute="true"
      :value="progress_overlay"
    >
      <v-progress-circular
        :value="progress"
      >
        {{ progress }}
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import GeneralSelect from '../components/GeneralSelect';
import Confirm from '../components/Confirm';
import ParallelViewer from '../components/ParallelViewer';
import { res_list } from "../js/res_list";
import { http_error } from "../js/http_error";

export default {
  name: 'term',
  components: {
    Breadcrumbs,
    GeneralSelect,
    Confirm,
    ParallelViewer
  },
  mixins: [res_list, http_error],
  props: {
    mode: String
  },
  data: function(){
    return {
      module_id: "29",
      nav_path: null,
      data: [],
      target: {
        layer: "",
        gid: "",
        uid: ""
      },
      progress: 0,
      progress_overlay: false,
      search_yid: "",
      search_term: "",
      module: "term",
      search_term_type: [
        "term"
      ],
      term_types_all: [
        {
          "label": "term",
          "value": "term"
        },
        {
          "label": "temporary",
          "value": "temporary"
        }
      ]
    }
  },
  methods: {
  },
  computed: {
    headers: function() {
      let table_headers = [
        {
          text: this.$i18n.t("message.common.yid"),
          value: 'yid',
          filter: value => {
            if(this.search_yid === "" || this.search_yid === null){
              return true;
            }
            return value.indexOf(this.search_yid) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.common.title"),
          value: 'name',
          filter: value => {
            if(this.search_term === "" || this.search_term === null){
              return true;
            }
            return value.indexOf(this.search_term) !== -1;
          },
          cellClass: 'title-column'
        },
        {
          text: this.$i18n.t("message.term.term_type"),
          value: 'type',
          filter: value => {
            if(!value
              && this.search_term_type.indexOf("temporary") >= 0){
              return true;
            }
            return this.search_term_type.indexOf(value) >= 0;
          }
        },
        { text: this.$i18n.t("message.common.lang_pair"), value: 'lang_pair' },
        {
          text: this.$i18n.t("message.term.line"),
          value: 'line',
          align: 'right'
        },
        { text: this.$i18n.t("message.common.ctime"), value: 'ctime' },
        {
          text: this.$i18n.t("message.common.operation"),
          value: 'operation',
          sortable: false
        }
      ];
      if(this.$vuetify.breakpoint.xs){
        table_headers.push({
        text: '',
        value: 'action',
        sortable: false
        });
      }
      return table_headers;
    },
    term_types: function(){
      var term_types = [];
      for(var term_type of this.term_types_all){
        term_types.push({
          label: this.$i18n.t('message.term.term_type_' + term_type.label),
          value: term_type.value
        });
      }
      return term_types;
    },
  }
}
</script>
<style scoped>
.term-table >>> .title-column {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(50vw - 300px);
}
.v-tooltip__content {
  word-break: break-all;
}
</style>
